/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FindOrCreateUser200ResponseData
 */
export interface FindOrCreateUser200ResponseData {
  /**
   * UUID пользователя
   * @type {string}
   * @memberof FindOrCreateUser200ResponseData
   */
  id: string
  /**
   * Одноразовый авторизационный код для /oaclients/exchange
   * @type {string}
   * @memberof FindOrCreateUser200ResponseData
   */
  code: string
  /**
   *
   * @type {string}
   * @memberof FindOrCreateUser200ResponseData
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof FindOrCreateUser200ResponseData
   */
  phone: string
  /**
   * Пользователь создан этим запросом
   * @type {boolean}
   * @memberof FindOrCreateUser200ResponseData
   */
  isUserCreated: boolean
  /**
   * Email пользователя подтверждён
   * @type {boolean}
   * @memberof FindOrCreateUser200ResponseData
   */
  userVerified: boolean
}

/**
 * Check if a given object implements the FindOrCreateUser200ResponseData interface.
 */
export function instanceOfFindOrCreateUser200ResponseData(
  value: object
): value is FindOrCreateUser200ResponseData {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('code' in value) || value['code'] === undefined) return false
  if (!('email' in value) || value['email'] === undefined) return false
  if (!('phone' in value) || value['phone'] === undefined) return false
  if (!('isUserCreated' in value) || value['isUserCreated'] === undefined)
    return false
  if (!('userVerified' in value) || value['userVerified'] === undefined)
    return false
  return true
}

export function FindOrCreateUser200ResponseDataFromJSON(
  json: any
): FindOrCreateUser200ResponseData {
  return FindOrCreateUser200ResponseDataFromJSONTyped(json, false)
}

export function FindOrCreateUser200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FindOrCreateUser200ResponseData {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    code: json['code'],
    email: json['email'],
    phone: json['phone'],
    isUserCreated: json['isUserCreated'],
    userVerified: json['userVerified'],
  }
}

export function FindOrCreateUser200ResponseDataToJSON(
  value?: FindOrCreateUser200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    code: value['code'],
    email: value['email'],
    phone: value['phone'],
    isUserCreated: value['isUserCreated'],
    userVerified: value['userVerified'],
  }
}
